import "#shared/styles/global.css";
import {
  registerI18nNamespace,
  setI18nNamespace,
} from "#shared/config/i18n.ts";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import { QueryClientProvider } from "@tanstack/react-query";
import { routeTree } from "#login/routeTree.gen.ts";
import loginEn from "#login/locales/en.json";
import { loadConfig } from "#shared/config/config.ts";
import { queryClient } from "#shared/config/query-client.ts";
import {
  AuthLoginProvider,
  authLoginStore,
} from "#login/store/auth-login-context.tsx";
import { initAnonymousApi } from "#login/lib/anonymous-api.ts";

const router = createRouter({
  routeTree,
  basepath: "/login",
  context: { authContext: undefined! },
  defaultPreload: "intent",
  defaultPreloadStaleTime: 0,
});

async function bootstrap() {
  await loadConfig();
  initAnonymousApi(authLoginStore);
  registerI18nNamespace("login", loginEn);
  setI18nNamespace("login");

  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <AuthLoginProvider>
          <RouterProvider
            router={router}
            context={{ authContext: undefined! }}
          />
        </AuthLoginProvider>
      </QueryClientProvider>
    </StrictMode>,
  );
}

void bootstrap();
